"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = __importStar(require("lodash"));
var Joins = /** @class */ (function () {
    function Joins(trees) {
        this.isJoinExists = function (rawJoin, joins) {
            if (joins.length === 0) {
                return false;
            }
            if (rawJoin.to === rawJoin.from) {
                return true;
            }
            for (var i = 0; i < joins.length; i++) {
                var join = joins[i];
                if (join.to === rawJoin.to && join.from === rawJoin.from) {
                    return true;
                }
                if (join.to === rawJoin.from && join.from === rawJoin.to) {
                    return true;
                }
            }
            return false;
        };
        this.generateJoins = function (tables) {
            var joins = [];
            if (tables.length === 1) {
                return [];
            }
            for (var i = 0; i < tables.length - 1; i++) {
                joins.push({ from: tables[i], to: tables[i + 1] });
            }
            return joins;
        };
        this.clipCommonAncestors = function (paths) {
            var lengthArray = paths.map(function (path) { return path.length; });
            var minArrayLength = Math.min.apply(Math, lengthArray);
            var minArrayIndex = lengthArray.indexOf(minArrayLength);
            var minArrayLastIndex = lengthArray.lastIndexOf(minArrayLength);
            if (minArrayIndex !== minArrayLastIndex) {
                return paths;
            }
            var pathsAsStrings = paths.map(function (path) { return path.join(","); });
            var minArrayString = pathsAsStrings[minArrayIndex];
            var isMinArrayExistsinAllPaths = false;
            for (var i = 0; i < pathsAsStrings.length; i++) {
                if (minArrayIndex === i) {
                    continue;
                }
                var pathsAsString = pathsAsStrings[i];
                if (pathsAsString.startsWith(minArrayString)) {
                    isMinArrayExistsinAllPaths = true;
                }
            }
            if (isMinArrayExistsinAllPaths) {
                paths = paths.map(function (path, index) {
                    return path.slice(minArrayLength - 1, path.length);
                });
            }
            return paths;
        };
        this.trees = trees;
    }
    Joins.prototype.getJoins = function (userTables) {
        var _this = this;
        var paths = this.getPath(userTables);
        var rawJoins = [];
        paths.forEach(function (path) {
            rawJoins.push(_this.generateJoins(path));
        });
        var flattenRawJoins = _.flattenDeep(rawJoins);
        var joins = [];
        for (var i = 0; i < flattenRawJoins.length; i++) {
            var rawJoin = flattenRawJoins[i];
            if (!this.isJoinExists(rawJoin, joins)) {
                joins.push(rawJoin);
            }
        }
        return joins;
    };
    Joins.prototype.getPath = function (tables) {
        var _this = this;
        var path = [];
        this.trees.forEach(function (tree) {
            tables.forEach(function (table) {
                var rootNodeName = Object.keys(tree)[0];
                var subPath = [];
                _this.getPathInTree(tree[rootNodeName], rootNodeName, table, path, subPath);
            });
        });
        return this.clipCommonAncestors(path);
    };
    Joins.prototype.getPathInTree = function (tree, nodeName, table, path, subPath) {
        var _this = this;
        subPath.push(nodeName);
        if (nodeName === table) {
            path.push(subPath);
            subPath = [];
            return true;
        }
        var nodeNames = Object.keys(tree);
        nodeNames.forEach(function (nodeName) {
            var subPath2 = JSON.parse(JSON.stringify(subPath));
            _this.getPathInTree(tree[nodeName], nodeName, table, path, subPath2);
        });
        return false;
    };
    return Joins;
}());
exports.default = Joins;
//# sourceMappingURL=Joins.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/Joins.js
// module id = 1576
// module chunks = 8